export const SET_OPEN_MENU_MODAL_DIALOG = 'SET_OPEN_MENU_MODAL_DIALOG';
export const SET_ID_MENU_MODAL_DIALOG = 'SET_ID_MENU_MODAL_DIALOG ';

export const setOpenMenuModalDialog = (isOpen) => ({
  type: SET_OPEN_MENU_MODAL_DIALOG,
  isOpen,
});

export const setIdMenuModalDialog = (id) => ({
  type: SET_ID_MENU_MODAL_DIALOG,
  id,
});
